import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import LogoRFID from '../imagenes/Logo animado.gif';

import {
    Container,
    Box,
    TextField,
    Button,
    Typography,
    MenuItem,
    Paper,
    CircularProgress,
    Alert
} from '@mui/material';

const Login = ({ setIsLoggedIn }) => {
    const [rut, setRut] = useState('');
    const [clave, setClave] = useState('');
    const [selectedEmpresa, setSelectedEmpresa] = useState('');
    const [empresas, setEmpresas] = useState([]);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        const fetchEmpresas = async () => {
            try {
                const response = await axios.get(process.env.REACT_APP_API_LOGIN_EMPRESAS);
                setEmpresas(response.data);
            } catch (err) {
                setError('Error al cargar empresas');
            }
        };

        fetchEmpresas();
    }, []);

    const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    if (!rut || !clave || !selectedEmpresa) {
        setError('Completa todos los campos');
        return;
    }

    try {
        setLoading(true);

        const response = await axios.post(
            process.env.REACT_APP_API_LOGIN,
            {
                rut,
                clave,
                idempresa: selectedEmpresa
            },
            {
                withCredentials: true
            }
        );

        const { usuario, access_token } = response.data;

        // 🔥 GUARDAR SESIÓN
        localStorage.setItem('usuario', JSON.stringify(usuario));
        localStorage.setItem('access_token', access_token);

        // 🔥 REDIRECCIÓN DIRECTA
        navigate('/dashboard');

    } catch (error) {
        if (error.response?.status === 401) {
            setError('Credenciales incorrectas');
        } else {
            setError('Error de conexión');
        }
    } finally {
        setLoading(false);
    }
};

    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <Paper
                    elevation={6}
                    sx={{
                        padding: 4,
                        borderRadius: 4,
                        width: '100%'
                    }}
                >
                    {/* Logo */}
                    <Box textAlign="center" mb={3}>
                        <img src={LogoRFID} alt="logo" style={{ width: '70%' }} />
                    </Box>

                    <Typography variant="h5" textAlign="center" mb={3}>
                        Iniciar Sesión
                    </Typography>

                    {error && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {error}
                        </Alert>
                    )}

                    <form onSubmit={handleLogin}>
                        {/* Empresa */}
                        <TextField
                            select
                            fullWidth
                            label="Empresa"
                            value={selectedEmpresa}
                            onChange={(e) => setSelectedEmpresa(e.target.value)}
                            margin="normal"
                        >
                            {empresas.map((empresa) => (
                                <MenuItem key={empresa.idempresa} value={empresa.idempresa}>
                                    {empresa.empresa}
                                </MenuItem>
                            ))}
                        </TextField>

                        {/* RUT */}
                        <TextField
                            fullWidth
                            label="Rut o Usuario"
                            value={rut}
                            onChange={(e) => setRut(e.target.value)}
                            margin="normal"
                        />

                        {/* Clave */}
                        <TextField
                            fullWidth
                            label="Contraseña"
                            type="password"
                            value={clave}
                            onChange={(e) => setClave(e.target.value)}
                            margin="normal"
                        />

                        {/* Botón */}
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            size="large"
                            sx={{ mt: 3, borderRadius: 2 }}
                            disabled={loading}
                        >
                            {loading ? <CircularProgress size={24} /> : 'Ingresar'}
                        </Button>
                    </form>

                    <Typography
                        variant="body2"
                        textAlign="center"
                        mt={3}
                        color="text.secondary"
                    >
                        Si no tienes contraseña, solicita acceso a soporte@rfid.cl
                    </Typography>
                </Paper>
            </Box>
        </Container>
    );
};

export default Login;